module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-support-box-image-sp-abe498a6268ae73251a1cbc1f4f5f0c3.jpg";